export default "__VITE_ASSET__ihaQS4C1__"